import type { FunctionComponent } from 'react';

import AddItemFromPosDrawer from 'components/MenuManagement/PointOfSale/AddItemFromPosDrawer';
import AddNewDrawer from 'components/MenuManagement/MenuItemActions/AddNewDrawer/AddNewDrawer';
import AddTypeChoiceDrawer from 'components/MenuManagement/MenuItemActions/AddTypeChoiceDrawer';
import type { AddNewDrawersProps } from 'components/MenuManagement/MenuItemActions/types/newDrawerTypes';

/* The add flow's drawers, split out of AddNewDrawerButton so the row actions popover can render
them as a sibling of its dropdown - see useAddNewDrawers. */
export const AddNewDrawers: FunctionComponent<AddNewDrawersProps> = ({
  parentRecord,
  itemType,
  addNewDrawerOpen,
  addNewDrawerHandlers,
  addTypeChoiceDrawerOpen,
  addTypeChoiceDrawerHandlers,
  addItemFromPosDrawerOpen,
  addItemFromPosDrawerHandlers,
  fromTypeChoice,
  setFromTypeChoice,
}) => (
  <>
    <AddNewDrawer
      itemType={itemType}
      parentRecord={parentRecord}
      opened={addNewDrawerOpen}
      close={addNewDrawerHandlers.close}
      openAddTypeChoiceDrawer={addTypeChoiceDrawerHandlers.open}
      fromTypeChoice={fromTypeChoice}
    />
    <AddTypeChoiceDrawer
      itemType={itemType}
      opened={addTypeChoiceDrawerOpen}
      close={addTypeChoiceDrawerHandlers.close}
      openAddNewDrawer={() => {
        setFromTypeChoice(true);
        addNewDrawerHandlers.open();
      }}
      openAddItemFromPosDrawer={addItemFromPosDrawerHandlers.open}
    />
    <AddItemFromPosDrawer
      itemType={itemType}
      parentRecord={parentRecord}
      opened={addItemFromPosDrawerOpen}
      closeAddItemFromPosDrawer={addItemFromPosDrawerHandlers.close}
      openAddItemFromPosDrawer={addItemFromPosDrawerHandlers.open}
      openAddTypeChoiceDrawer={addTypeChoiceDrawerHandlers.open}
    />
  </>
);
